import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'PROJECT_KNOWLEDGE_SET_GENESET_CACHE',
  'PROJECT_KNOWLEDGE_REMOVE_GENESET_FROM_CACHE',
  'PROJECT_KNOWLEDGE_UPDATE_GENESET_IN_CACHE',
  'PROJECT_KNOWLEDGE_SET_PENDING_DELETE_GENESET',
  'PROJECT_KNOWLEDGE_ADD_GENESET_TO_CACHE',
]);
